import {Nullish} from 'utility-types';

export const stringToBoolean = (value: string | Nullish): boolean => {
  if (value === 'true') {
    return true;
  }

  return false;
};
